<script>
    import jQuery from "jquery";
    import {getGPTransFunc} from "./gp-translations.js";
    let trans = getGPTransFunc("gp-login");
    let params = null;
    let resolve;
    let email = "";
    let password = "";
    let sending = false;
    let error = null;
    $: disabled = !(email.length > 0 && password.length > 0) || sending;
    export let sendLogin;

    export function open() {
        return new Promise(((res) => {
            jQuery('#GPLogin').modal({});
            jQuery('#GPLogin').on('hidden.bs.modal', () => this.$destroy())
            resolve = res;
        }))
    }
    
    async function loginConfirmed () {
        if (disabled) return;

        sending = true;
        error = null;

        let res = await sendLogin(email, password);

        if (res.result === "OK") {
            sending = false;
            jQuery('#GPLogin').modal('hide');
            resolve(res);
          } else {
            sending = false;
            error = trans("Email or password incorrect");
        }
    }

</script>

<div class="modal fade GPModal" id="GPLogin">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">{trans("Login")}</h4>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <span class="help-block">{trans("To use this feature you have to login to GardenPuzzle account")}.</span>
                </div>
                <div class="form-group">
                    <label class="control-label" for="GPLoginEmail">{trans("Email or username")}: </label>
                    <input bind:value={email} class="form-control" placeholder="" type="text" id="GPLoginEmail" name="GPLoginEmail" required>
                </div>
                <div class="form-group">
                    <label class="control-label" for="GPLoginPass">{trans("Password")}: </label>
                    <input bind:value={password} class="form-control" placeholder="" type="password" id="GPLoginPass" name="GPLoginPass" required>
                </div>
                {#if error}
                    <div class="form-group">
                        <span class="help-block error-message">{error}</span>
                    </div>
                    <div class="form-group">
                        <span class="help-block problems-with-loading">{trans("Don't remember the password?")} <a href='{GPSettings.webSiteAddr}/accounts/password/reset/' target='_blank'>{trans("Click here")}</a> {trans("to reset it")}.</span>
                    </div>
                {/if}
                    <div class="form-group">
                        <span class="help-block problems-with-loading">{trans("New user?")} <a href='{GPSettings.webSiteAddr}/accounts/appsignup?next=/accounts/appsignup_success' target='_blank'>{trans("Click here")}</a> {trans("to set up a new account")}.</span>
                    </div>
                <div class="form-group">
                    <button class:disabled on:click="{loginConfirmed}" class="btn btn-primary" id="GPLoginConfirm">{trans("Login")} {#if sending}<i class="button-waiting fa fa-spinner fa-spin" style="display: inline-block"></i>{/if} </button>
                </div>
            </div>
            <div class="modal-footer">
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->